export default __webpack_public_path__ + "assets/images/f2f819f79eb4c351845f45d6dc81e7e2.png";